import { Component, OnInit, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import {
    NbAuthSocialLink,
    NbAuthService,
    NB_AUTH_OPTIONS,
    NbAuthResult,
    getDeepFromObject,
    NbLoginComponent
} from '@nebular/auth';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../../@core/utils/analytics.service';
import { Store } from '@ngrx/store';
import { PagesState } from 'app/pages/pages-state';
import { loginSuccess } from 'app/store/meta/meta.actions';

@Component({
    selector: 'ngx-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NgxLoginComponent extends NbLoginComponent {
    redirectDelay = 0;
    showMessages: any = {};
    strategy = '';

    errors: string[] = [];
    messages: string[] = [];
    user: any = {};
    submitted = false;
    socialLinks: NbAuthSocialLink[] = [];
    rememberMe = false;

    constructor(
        protected service: NbAuthService,
        @Inject(NB_AUTH_OPTIONS) protected options = {},
        protected cd: ChangeDetectorRef,
        protected router: Router,
        private analytics: AnalyticsService,
        private pagesStore: Store<PagesState>
    ) {
        super(service, options, cd, router);
        this.redirectDelay = this.getConfigValue('forms.login.redirectDelay');
        this.showMessages = this.getConfigValue('forms.login.showMessages');
        this.strategy = this.getConfigValue('forms.login.strategy');
        this.socialLinks = this.getConfigValue('forms.login.socialLinks');
        this.rememberMe = this.getConfigValue('forms.login.rememberMe');
    }

    login(): void {
        localStorage.removeItem('auth_app_token'); // to handle caching bugs we make sure the user is completely logged out

        this.errors = [];
        this.messages = [];
        this.submitted = true;

        this.service.authenticate(this.strategy, this.user).subscribe((result: NbAuthResult) => {
            this.submitted = false;
            if (result.isSuccess()) {
                this.messages = result.getMessages();
                this.analytics.gaEvent('Login', 'Login success');

                this.pagesStore.dispatch(loginSuccess());
            } else {
                this.errors = result.getErrors();
                this.analytics.gaEvent('Login', 'Login unsuccessful');
            }

            const redirect = result.getRedirect();
            if (redirect) {
                setTimeout(() => {
                    return this.router.navigateByUrl(redirect);
                }, this.redirectDelay);
            }
            this.cd.detectChanges();
        });
    }

    onEmailInput(event): void {
        event.target.value = event.target.value.toLowerCase();
    }

    getConfigValue(key: string): any {
        return getDeepFromObject(this.options, key, null);
    }
}
